import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import {useSettingsApi} from "@store/api/settingsApi";
import {useI18n} from "vue-i18n";

export const useCommonStore = defineStore('common', () => {
	const {t} = useI18n();
	const settingsApi = useSettingsApi();
	const communicationLink = ref('https://telegram.me/step_bot_support');
	const availableFlags: Record<string, string> = {
		en: "/images/flags/us.png",
		ru: "/images/flags/ru.png",
		pl: "/images/flags/pl.png",
		kz: "/images/flags/kz.png",
		es: "/images/flags/es.png"
	};

	const links = ref({
		policy: 'https://help.step-vpn.com/personal-data-processing-policy',
		terms: 'https://help.step-vpn.com/user-agreement'
	})

	const languages = ref([
		{
			locale: "ru",
			name: t('common.languages.ru'),
			image: "/images/flags/ru.png"
		},
		{
			locale: "en",
			name: t('common.languages.en'),
			image: "/images/flags/us.png"
		},
		{
			locale: "es",
			name: t('common.languages.es'),
			image: "/images/flags/es.png"
		},
	]);

	const mainMenu = computed(() => ([
		{
			url: "/",
			title: t('common.bar.home'),
			icon: {
				name: "home",
				viewBox: "0 0 19 18"
			}
		},
		{
			url: "/help",
			title: t('common.bar.help'),
			icon: {
				name: "comment-2-dots",
				viewBox: "0 0 19 18"
			}
		},
		{
			url: "/account",
			title: t('common.bar.cabinet'),
			icon: {
				name: "user",
				viewBox: "0 0 19 20"
			}
		},
	]));

	const init = async () => {
		let settingsInfo = await settingsApi.getSettings();
		languages.value = settingsInfo.available_lang.map(locale => ({
			locale,
			name: t(`common.languages.${locale}`),
			image: availableFlags[locale] ?? '/images/flags/default.png'
		}));
	}

	return {
		init,
		links,
		languages,
		mainMenu,
		communicationLink
	};
})
